import React, { Fragment, useMemo } from 'react';
import { addMinutes } from 'date-fns';
import { styled } from 'styled-components';
import { Layout, List, LogoContainerPlaceholder } from './GridChannel';
import { Colors } from '../../../../../play-core/styles/Colors';
import { centralEuropeanNow } from '../../../../../play-core/utils/date-helper';
import { isoDate } from '../../../utils/date-formatter';
import { gridGap, positionInTvDay, roundTo, startOfTvDayInCET } from '../tv-guide-types';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const GridPlaceholder = ({
  isLoading,
  pixelsPerMinute,
  placeholderChannelCount
}) => {
  const date = isoDate(centralEuropeanNow());
  const placeholderProgram = useMemo(() => createPlaceholderProgram(placeholderChannelCount, date), [placeholderChannelCount, date]);
  return /*#__PURE__*/_jsx(Fragment, {
    children: isLoading && placeholderProgram.map((channelProgram, index) => /*#__PURE__*/_jsxs(Layout, {
      pixelsPerMinutes: pixelsPerMinute,
      children: [/*#__PURE__*/_jsx(LogoContainerPlaceholder, {
        children: /*#__PURE__*/_jsx(ChannelPlaceHolder, {})
      }), /*#__PURE__*/_jsx(List, {
        children: isLoading && channelProgram.map((programEntry, i) => {
          const left = positionInTvDay(programEntry.startTime, date, pixelsPerMinute);
          const right = positionInTvDay(programEntry.endTime, date, pixelsPerMinute);
          return /*#__PURE__*/_jsx(ProgramEntryPlaceholder, {
            style: {
              left: `${left}px`,
              width: `${right - left}px`
            }
          }, i);
        })
      })]
    }, index))
  });
};
const ProgramEntryPlaceholder = styled.div.withConfig({
  displayName: "GridPlaceholder__ProgramEntryPlaceholder",
  componentId: "sc-5bgm0a-0"
})(["position:absolute;height:100%;background-color:", ";border-right:", "px solid ", ";"], Colors.GREY_222222, gridGap, Colors.GREY_1a1a1a);
const ChannelPlaceHolder = styled.div.withConfig({
  displayName: "GridPlaceholder__ChannelPlaceHolder",
  componentId: "sc-5bgm0a-1"
})(["width:70px;height:26px;background-color:", ";"], Colors.GREY_3a3a3a);
const createPlaceholderProgram = (channelCount, date) => {
  const startOfDay = startOfTvDayInCET(date);
  const totalMinutes = 60 * 24;
  const programs = [];
  for (let i = 0; i < channelCount; i += 1) {
    const channelProgram = [];
    let filledMinutes = 0;
    // bring in some controlled random, make sure server and client render are equal
    const startDuration = (i + 1) / 11;
    while (filledMinutes < totalMinutes) {
      const deterministicVariation = filledMinutes / startDuration % 57;
      // to have a duration between 10, 60
      let duration = roundTo(Math.max(deterministicVariation, 10), 5);
      if (filledMinutes + duration >= totalMinutes) {
        duration = totalMinutes - filledMinutes;
      }
      channelProgram.push({
        startTime: addMinutes(startOfDay, filledMinutes).toISOString(),
        endTime: addMinutes(startOfDay, filledMinutes + duration).toISOString()
      });
      filledMinutes += duration;
    }
    programs.push(channelProgram);
  }
  return programs;
};